/**
 * @fileoverview gRPC-Web generated client stub for position
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.30.0-rc1
// source: service.proto

/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.position = require('./service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.position.PositionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.position.PositionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.position.PositionRequest,
 *   !proto.position.PositionResponse>}
 */
const methodDescriptor_PositionService_StreamPosition = new grpc.web.MethodDescriptor(
  '/position.PositionService/StreamPosition',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.position.PositionRequest,
  proto.position.PositionResponse,
  /**
   * @param {!proto.position.PositionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.position.PositionResponse.deserializeBinary
);


/**
 * @param {!proto.position.PositionRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.position.PositionResponse>}
 *     The XHR Node Readable Stream
 */
proto.position.PositionServiceClient.prototype.streamPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/position.PositionService/StreamPosition',
      request,
      metadata || {},
      methodDescriptor_PositionService_StreamPosition);
};


/**
 * @param {!proto.position.PositionRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.position.PositionResponse>}
 *     The XHR Node Readable Stream
 */
proto.position.PositionServicePromiseClient.prototype.streamPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/position.PositionService/StreamPosition',
      request,
      metadata || {},
      methodDescriptor_PositionService_StreamPosition);
};


module.exports = proto.position;

